import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';
import { PathTopic } from './../builders/path_topic_builder';

angular
  .module('data-ng-todos')
  .factory(
    'loadAllTopicsCommand',
    function loadAllTopicsCommandDefinition(
      $http: ng.IHttpService,
      defineCommand: IDefineCommand,
      ngPathCurrentTopicDatastore: IDatasource<PathTopic>,
      log: any
    ) {
      return defineCommand('loadAllTopicsCommand', function loadAllTopicsCommand(deferred: ng.IDeferred<any>): any {
        $http
          .get('/item/studenttopic/')
          .then((response: any) => {
            ngPathCurrentTopicDatastore.clear();
            ngPathCurrentTopicDatastore.write(response.data.topic);
            ORM.run();
            deferred.resolve();
          })
          .catch((e) => {
            log.issue('Failed to retrieve all topics.');
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/commands/load_all_topics_command.ts